import { create } from './deferred';
import { loadScript } from './load-script';

// 字段映射层
export interface IClient {
    /**
     * 是否处于飞书浏览器
     */
    isFeiShu: boolean
}

// Support both Vite (VITE_) and Vue CLI (VUE_APP_) environment variables
function getEurekaUri(): string {
    // Check for Vite environment variable first
    if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_EUREKA_URI) {
        return import.meta.env.VITE_EUREKA_URI;
    }
    // Fall back to Vue CLI environment variable
    if (typeof process !== 'undefined' && process.env?.VUE_APP_EUREKA_URI) {
        return process.env.VUE_APP_EUREKA_URI;
    }
    // Default fallback
    return '';
}

// Using local copy instead of external CDN for better performance and reliability
const FEISHU_H5_SDK = `${getEurekaUri()}/feishu/h5-js-sdk-1.5.16.js`;

export const clientDeferred = create<IClient>();

export const getClient = () => Promise.all([loadScript(FEISHU_H5_SDK)]).then(([_sdk]) => {
    const isFeiShu = !!window.h5sdk && !!window.tt;
    clientDeferred.resolve({
        isFeiShu,
    })
    return [_sdk];
}).catch((error) => {
    console.warn('[client.ts] Failed to load Feishu H5 SDK, continuing without it:', error);
    clientDeferred.resolve({
        isFeiShu: false,
    });
});

getClient();
